export const formatSeconds = (s: number) => {
  const d = Math.floor(s / (3600 * 24));
  s -= d * 3600 * 24;
  const h = Math.floor(s / 3600);
  s -= h * 3600;
  const m = Math.floor(s / 60);
  s -= m * 60;

  const tmp = [] as string[];
  if (d) tmp.push(`${d}d`);
  if (d || h) tmp.push(`${h}h`);
  if (d || h || m) tmp.push(`${m}m`);
  tmp.push(`${Math.round(s)}s`);
  return tmp.join(' ');
};
